import { Decodable } from './_decodable';
import { PurchaseOrderItem } from './purchase-order-item';
import { Supplier } from './supplier';

class PurchaseOrder extends Decodable {
    static readonly STATUS_CREATED = 1;
    static readonly STATUS_SENT = 2;
    static readonly STATUS_QUOTED = 3;
    static readonly STATUS_FINISHED = 4;

    // "Ordem" é feminino: o painel usa estes rótulos em vez do status_name da API
    // (que ainda manda "Cotado"/"Finalizado").
    static readonly STATUS_OPTIONS: ReadonlyArray<{ value: number; label: string }> = [
        { value: PurchaseOrder.STATUS_CREATED, label: 'Criada' },
        { value: PurchaseOrder.STATUS_SENT, label: 'Enviada ao fornecedor' },
        { value: PurchaseOrder.STATUS_QUOTED, label: 'Cotada' },
        { value: PurchaseOrder.STATUS_FINISHED, label: 'Finalizada' },
    ];

    static statusLabel(status?: number | null): string {
        return PurchaseOrder.STATUS_OPTIONS.find(option => option.value === Number(status))?.label || '';
    }

    /** Tom do selo (Badge "quiet" do DS; as cores de status de orçamento são só para orçamento) */
    static statusTone(status?: number | null): 'neutral' | 'info' | 'warning' | 'success' {
        switch (Number(status)) {
            case PurchaseOrder.STATUS_SENT: return 'info';
            case PurchaseOrder.STATUS_QUOTED: return 'warning';
            case PurchaseOrder.STATUS_FINISHED: return 'success';
            default: return 'neutral';
        }
    }

    /** Próximo passo do fluxo (Criada → Enviada → Cotada → Finalizada) */
    static nextStatusAction(status?: number | null): { label: string; icon: string; nextStatus: number; dateField: string } | null {
        switch (Number(status)) {
            case PurchaseOrder.STATUS_CREATED:
                return { label: 'Enviar ao fornecedor', icon: 'send', nextStatus: PurchaseOrder.STATUS_SENT, dateField: 'sent_at' };
            case PurchaseOrder.STATUS_SENT:
                return { label: 'Marcar como cotada', icon: 'request_quote', nextStatus: PurchaseOrder.STATUS_QUOTED, dateField: 'quoted_at' };
            case PurchaseOrder.STATUS_QUOTED:
                return { label: 'Finalizar', icon: 'check_circle', nextStatus: PurchaseOrder.STATUS_FINISHED, dateField: 'finished_at' };
            default:
                return null;
        }
    }

    id?: number;
    supplierId?: number;
    orderDate?: Date;
    purchaseDate?: Date;
    purchaseValue: number = 0;
    totalValue: number = 0;
    invoiceNumber?: string;
    invoiceDocument?: string;
    notes?: string;
    status?: number;
    statusName?: string;
    statusClass?: string;
    tokenLink?: string;
    sentAt?: Date;
    quotedAt?: Date;
    finishedAt?: Date;
    createdAt?: Date;
    updatedAt?: Date;

    supplier?: Supplier;
    items?: PurchaseOrderItem[];

    protected _map = {
        status: (e: any) => e === null || e === undefined ? e : Number(e),
        orderDate: (e: any) => this.parseDate(e),
        purchaseDate: (e: any) => this.parseDate(e),
        sentAt: (e: any) => this.parseDate(e),
        quotedAt: (e: any) => this.parseDate(e),
        finishedAt: (e: any) => this.parseDate(e),
        createdAt: (e: any) => this.parseDate(e),
        updatedAt: (e: any) => this.parseDate(e),
        supplier: (e: any) => Supplier.parse(e),
        items: (e: any) => PurchaseOrderItem.parse(e),
    };
}

export { PurchaseOrder };
